export default {"src":"/_next/static/media/cloud-assess.b725a6e8.svg","height":208,"width":1084,"blurWidth":0,"blurHeight":0};